import { cloneDeep, defaultsDeep } from 'lodash'
import { Tag } from '../models/tag.entity'

// Initial state

const TAG_INITIAL_STATE: Partial<Tag> = {
  target: 'products',
}

// Init

export function initTag(tag: Partial<Tag> = {}): Tag {
  return defaultsDeep(cloneDeep(tag), TAG_INITIAL_STATE)
}
